import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from "@angular/router";
import { SharedService } from "../services/shared.service";
import { CclMessageService } from "certain-common-library";
import * as moment from 'moment';
import 'moment-timezone';

@Injectable()
export class CatalogUuidResolver implements Resolve<object> {
    constructor(private route: ActivatedRoute, private sharedService: SharedService, private messageService: CclMessageService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): object {
        this.sharedService.redirectTo = route.url[0].path;
        const catalogUUID = route.paramMap.get("catalogUuid");
        this.sharedService.catalogUUID = catalogUUID;
        this.sharedService.timezone = moment.tz.guess(true);
        this.route.queryParams.subscribe(params => {
        if(params["mysessions"] == 'true') {
            this.sharedService.mysessions = true
            this.sharedService.myfav = false
        } else if (params["myfav"] == 'true') {
            this.sharedService.mysessions = false
            this.sharedService.myfav = true
        }

        if (params['filterName']) {
            this.sharedService.filterName = params["filterName"];
        }
            
        if (params["mytimezone"] == 'true'){
            this.sharedService.timezone = moment.tz.guess(true);
        }
        });
        this.messageService.sendMessage("initialize-app", catalogUUID);
        return { catalogUUID: catalogUUID };
    }
}
